import Vue from 'vue';
import Component from 'vue-class-component';

@Component
export class AvatarMixin extends Vue {
	// Person
	personAvatar = {
		size: '80',
		color: 'primary lighten-3',
	};

	// Noti Dot (with numbers)
	notiTextDot = {
		size: '20',
		color: 'badge',
		minWidth: 'max-content',
		minHeight: '24px',
		class: 'rounded-xl primary--text text--darken-2',
	};

	notiTextDotText = {
		class: 'reminder-text px-2 py-2',
	};

	timelineActionDot = {
		size: '24',
		color: 'yellow',
	};

	timelineActionDotIcon = {
		size: '16',
		color: 'mono800',
	};
}
